export enum SmsQuotaType {
  DCv2 = 'DCv2',
  I4B = 'I4B'
}
